/**
 * Plain-string constants for Primum contact addresses. Intentionally kept in a separate file
 * from `constants/links.ts` so consumers can import them without triggering the
 * env-var validation that some of the URL constants depend on.
 */

export const SUPPORT_EMAIL_ADDRESS = 'support@primum.co';

export const SUPPORT_EMAIL_LINK = `mailto:${SUPPORT_EMAIL_ADDRESS}?subject=Support%20Request`;

export const GENERAL_EMAIL_ADDRESS = 'hello@primum.co';

export const GENERAL_EMAIL_LINK = `mailto:${GENERAL_EMAIL_ADDRESS}`;

/**
 * How to reach support, for copy that ends with it. A signed-in member is
 * pointed at Contact Support in their account menu, which opens their support
 * thread, or the form for an account still in confirmation. Anyone else gets
 * the address.
 */
export function supportContactHint(isSignedIn: boolean): string {
  return isSignedIn
    ? 'use Contact Support in your account menu'
    : `contact support at ${SUPPORT_EMAIL_ADDRESS}`;
}
